import { connect } from 'react-redux'
import Settings from '../components/Settings'

const mapStateToProps = (state, ownProps) => {
  const { width } = state.window
  const { user } = state.authentication
  const { settings } = state.settings
  return ({
    width,
    user,
    settings,
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
    init: (user) => {
    }
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Settings)


// WEBPACK FOOTER //
// ./src/Pages/Settings/containers/Settings.js